import { call, put, takeLatest } from "redux-saga/effects";
import request from "@util/net/request";
import { AxiosResponse } from "axios";
import {
  ConfigActions,
  GET_STYLING_FILTERS,
  StylingFilterActions
} from "@redux/reducer";
import { FiltersPayload, FiltersResponse, StylingAbbrType } from "@type/index";
import { CategoryFilterMapper } from "@util/queryPatamter";
import { checkCoordinate, checkFeatureCode } from "@util/net";

export function* getStylingFiltersSaga(action: { payload: FiltersPayload }) {
  try {
    const payload: FiltersPayload = action.payload;
    yield put(StylingFilterActions.getStylingFiltersLoading(true));
    const res: AxiosResponse<FiltersResponse> = yield call(
      request.get,
      "/styles/filters",
      {
        params: {
          ...payload
        }
      }
    );

    if (res.data.result.styleCategories) {
      res.data.result.styleCategories = CategoryFilterMapper(
        res.data.result.styleCategories
      );
    }
    // Only check feature and coordinate if the type is SB
    if (payload.type === StylingAbbrType.SB) {
      checkFeatureCode(res.data.result.features || []);
      checkCoordinate(res.data.result.tagCategories || []);
    } else {
      yield put(ConfigActions.setUrlChange(false));
      yield put(ConfigActions.setUrlParams(""));
    }
    yield put(StylingFilterActions.getStylingFiltersSuccess(res.data.result));
  } catch (error) {
    yield put(StylingFilterActions.getStylingFiltersLoading(false));
  }
}

export function* watchLoadStylingFiltersSaga() {
  yield takeLatest<any>(GET_STYLING_FILTERS, getStylingFiltersSaga);
}
